import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import filterActiveIcon from 'assets/filter-active.svg';
import filterIcon from 'assets/filter.svg';
import {
  selectActiveNotifications,
  setActiveNotifications,
} from 'features/notifications/notificationsSlice';

import {
  FilterButton,
  FilterIcon,
  FilterWrapper,
  ToggleButton,
  ToggleContainer,
} from './NotifToggle.styles';

const Toggle = ({ onChange }) => {
  const activeNotifications = useSelector(selectActiveNotifications);
  const dispatch = useDispatch();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleToggle = (filter) => {
    let updatedFilters;

    if (filter === 'all') {
      updatedFilters = ['all'];
    } else {
      updatedFilters = activeNotifications.includes(filter)
        ? activeNotifications.filter((f) => f !== filter)
        : [...activeNotifications.filter((f) => f !== 'all'), filter];
      if (updatedFilters.length === 0) {
        updatedFilters = ['all'];
      }
    }

    dispatch(setActiveNotifications(updatedFilters));
    onChange(updatedFilters);
  };

  const activeCount = activeNotifications.filter((f) => f !== 'all').length;

  return (
    <FilterWrapper>
      <FilterButton
        $isOpen={isFilterOpen}
        $isActive={activeCount > 0}
        onClick={() => setIsFilterOpen(!isFilterOpen)}
      >
        <FilterIcon
          src={activeCount > 0 || isFilterOpen ? filterActiveIcon : filterIcon}
          alt="filter"
        />
        Filter {activeCount > 0 && `(${activeCount})`}
      </FilterButton>

      {isFilterOpen && (
        <ToggleContainer>
          <ToggleButton
            $active={activeNotifications.includes('all')}
            onClick={() => handleToggle('all')}
          >
            All
          </ToggleButton>
          <ToggleButton
            $active={activeNotifications.includes('appointment')}
            onClick={() => handleToggle('appointment')}
          >
            Appointment
          </ToggleButton>
          <ToggleButton
            $active={activeNotifications.includes('financial')}
            onClick={() => handleToggle('financial')}
          >
            Finance
          </ToggleButton>
          <ToggleButton
            $active={activeNotifications.includes('sales')}
            onClick={() => handleToggle('sales')}
          >
            Sales
          </ToggleButton>
          <ToggleButton
            $active={activeNotifications.includes('unread')}
            onClick={() => handleToggle('unread')}
          >
            Unread
          </ToggleButton>
        </ToggleContainer>
      )}
    </FilterWrapper>
  );
};

export default Toggle;
